/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getSecret } from '../fn/manage-secrets/get-secret';
import { GetSecret$Params } from '../fn/manage-secrets/get-secret';
import { SecretResponse } from '../models/secret-response';
import { upsertSecret } from '../fn/manage-secrets/upsert-secret';
import { UpsertSecret$Params } from '../fn/manage-secrets/upsert-secret';

@Injectable({ providedIn: 'root' })
export class ManageSecretsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSecret()` */
  static readonly GetSecretPath = '/secrets/{secretName}';

  /**
   * Fetch secret by name.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSecret()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSecret$Response(params: GetSecret$Params, context?: HttpContext): Observable<StrictHttpResponse<SecretResponse>> {
    return getSecret(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch secret by name.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSecret$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSecret(params: GetSecret$Params, context?: HttpContext): Observable<SecretResponse> {
    return this.getSecret$Response(params, context).pipe(
      map((r: StrictHttpResponse<SecretResponse>): SecretResponse => r.body)
    );
  }

  /** Path part for operation `upsertSecret()` */
  static readonly UpsertSecretPath = '/secrets/{secretName}';

  /**
   * Create or update a secret.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertSecret()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertSecret$Response(params: UpsertSecret$Params, context?: HttpContext): Observable<StrictHttpResponse<SecretResponse>> {
    return upsertSecret(this.http, this.rootUrl, params, context);
  }

  /**
   * Create or update a secret.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertSecret$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertSecret(params: UpsertSecret$Params, context?: HttpContext): Observable<SecretResponse> {
    return this.upsertSecret$Response(params, context).pipe(
      map((r: StrictHttpResponse<SecretResponse>): SecretResponse => r.body)
    );
  }

}
